import React from 'react';

export const PrivacyPolicy = () => {
  return <iframe title="privacy" src="Privacy.html"></iframe>;
};
